(function () {

  function updateDeliveryFee(cart) {
    const row = document.getElementById('delivery-fee-row');
    if (!row || !cart) return;

    const mov = parseInt(row.dataset.mov);
    const fee = parseInt(row.dataset.fee);
    const subtotal = cart.items_subtotal_price;

    const amountEl = document.getElementById('delivery-amount');
    const msgEl = document.getElementById('delivery-msg');

    if (!amountEl) return;

    if (subtotal < mov) {
      amountEl.innerHTML = `₹ ${fee}`;
      if (msgEl) msgEl.innerHTML = ``;
    } else {
      amountEl.innerHTML = `Free`;
      if (msgEl) msgEl.innerHTML = ``;
    }
  }

  /* ========== FETCH FULL CART AFTER ANY CART CHANGE ========== */
  function refreshCartAndUpdateFee() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateDeliveryFee(cart));
  }

  /* ================= FETCH HOOK ================= */
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {
      const url = arguments[0];

      if (typeof url === 'string' && url.includes('/cart/')) {
        // Add to cart returns only line item → fetch full cart
        if (url.includes('/cart/add')) {
          refreshCartAndUpdateFee();
        } else {
          response.clone().json().then(cart => {
            updateDeliveryFee(cart);
          }).catch(() => {});
        }
      }

      return response;
    });
  };

  /* ================= XHR HOOK ================= */
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function () {
    this.addEventListener('load', function () {
      try {
        if (this.responseURL.includes('/cart/')) {
          // cart/add.js → fetch full cart
          if (this.responseURL.includes('/cart/add')) {
            refreshCartAndUpdateFee();
          } else {
            const cart = JSON.parse(this.responseText);
            updateDeliveryFee(cart);
          }
        }
      } catch (e) {}
    });

    return originalOpen.apply(this, arguments);
  };

  /* ================= INITIAL LOAD ================= */
  refreshCartAndUpdateFee();

})();

/* Count */
document.addEventListener("DOMContentLoaded", () => {

  /* LIVE VIEWS (900+) */
  const liveViewEls = document.querySelectorAll('.live-view-count');

  if (liveViewEls.length > 0) {
    const updateLiveViews = () => {
      const views = Math.floor(Math.random() * 200) + 900; // 900–1099
      liveViewEls.forEach(el => {
        el.textContent = views;
      });
    };

    updateLiveViews();
    setInterval(updateLiveViews, 5000);
  }


  /* SOLD PRODUCTS (50+) */
  const soldEls = document.querySelectorAll('.sold-products-count');

  if (soldEls.length > 0) {
    const updateSoldCount = () => {
      const sold = Math.floor(Math.random() * 50) + 50; // 50–99
      soldEls.forEach(el => {
        el.textContent = `${sold}+ sold`;
      });
    };

    updateSoldCount();
    setInterval(updateSoldCount, 7000);
  }

});


/** minus remove func */
function toggleMiniCartButtons() {
  var cartItems = document.querySelectorAll('.cart-item');
  if (!cartItems || cartItems.length === 0) return;

  for (var i = 0; i < cartItems.length; i++) {
    var item = cartItems[i];

    var qtyInput = item.querySelector('input.quantity-input');
    var actions = item.querySelector('.minicart__actions');

    if (!qtyInput || !actions) continue;

    var qty = Number(qtyInput.value || qtyInput.getAttribute('data-value') || 1);

    if (qty > 1) {
      actions.classList.add('show-minus');
    } else {
      actions.classList.remove('show-minus');
    }
  }
}

/* Safe runner */
function safeToggle() {
  try {
    toggleMiniCartButtons();
  } catch (e) {
    console.warn('MiniCart toggle skipped:', e);
  }
}

/* Page load */
document.addEventListener('DOMContentLoaded', function () {
  setTimeout(safeToggle, 300);
});

/* Quantity buttons */
document.addEventListener('click', function (e) {
  if (e.target.closest && e.target.closest('.quantity__button')) {
    setTimeout(safeToggle, 200);
  }
});

/* Cart injection */
var debounce;
var observer = new MutationObserver(function () {
  clearTimeout(debounce);
  debounce = setTimeout(safeToggle, 100);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


/* =========================
   PROMO CALCULATION
========================= */
console.log('PROMO JS LOADED');

function updateCartSavings() {
  let totalSaved = 0;

  document.querySelectorAll('.cart-item').forEach(item => {
    const saving = Number(item.dataset.saving || 0);
    const qty = Number(item.dataset.qty || 1);

    totalSaved += saving * qty;
  });

  const wrapper = document.getElementById('Details-CartDrawer');
  const amount = document.getElementById('cart-saved-amount');

  if (!wrapper || !amount) return;

  if (totalSaved > 0) {
    wrapper.style.display = 'block';
    amount.innerText = `₹${(totalSaved / 100).toFixed(2)}`;
  } else {
    wrapper.style.display = 'none';
    amount.innerText = '₹0';
  }
}

/* Qty / remove detect */
document.addEventListener('click', e => {
  if (
    e.target.closest('.quantity__button') ||
    e.target.closest('.cart-remove')
  ) {
    setTimeout(updateCartSavings, 400);
  }
});

/* Drawer rebuild */
new MutationObserver(() => {
  setTimeout(updateCartSavings, 300);
}).observe(document.body, {
  childList: true,
  subtree: true
});

/* Initial */
document.addEventListener('DOMContentLoaded', updateCartSavings);

